// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2OUm0","choiceBoxes":"toolbarselects_choiceBoxes__2Asz_","simpleField":"toolbarselects_simpleField__1LaK8"};